import ValidateBuilder from 'app/utils/validators/validator';

export const getValidateExportData = () => {
  const validateBuilder = new ValidateBuilder();

  validateBuilder.addField('content', 'string', [
    { type: 'required', message: 'Content is required' }
  ]);

  validateBuilder.addField(
    'range',
    'array',
    [
      {
        type: 'test',
        message: 'Inspection Date is required',
        test(value) {
          if (Array.isArray(value)) return value.length === 2;
          return false;
        }
      }
    ],
    'string'
  );
  return validateBuilder.build();
};
